import {state} from 'lit/decorators.js';
import {LitElement, PropertyValues} from 'lit';
import {SpDialog} from './sp-dialog';

type Constructor<T> = new (...args: any[]) => T;

class SpEmbeddedClass<DialogType> {
    dialog: DialogType;
}

// Use this Mixin for templates that are embedded into a SpDialog or a SpDefaultDialog in order to access the sp-dialog
export const SpEmbedded = <DialogType extends SpDialog>() =>
    <EmbeddedType extends Constructor<LitElement>>(Base: EmbeddedType): EmbeddedType & Constructor<SpEmbeddedClass<DialogType>> => {
        class SpEmbedded extends Base {
            @state()
            dialog: DialogType;

            protected firstUpdated(_changedProperties: PropertyValues) {
                super.firstUpdated(_changedProperties);
                // Find correct original sp-dialog and assign to "@state() sp-dialog". This might be the sp-dialog instance itself or it's "originalDialogInstance" when it has a diverging render target.
                let tmpDiag;

                if (this.shadowRoot.host.parentElement.parentElement.nodeName === 'SL-DIALOG')
                    tmpDiag = ((this.shadowRoot.host.parentElement.parentElement.getRootNode() as ShadowRoot).host as any);
                else
                    tmpDiag = ((this.shadowRoot.host.parentElement.parentElement.parentElement.getRootNode() as ShadowRoot).host as any).originalDialogInstance;
                this.dialog = tmpDiag.originalDialogInstance ? tmpDiag.originalDialogInstance : tmpDiag;
            }
        }
        return SpEmbedded;
    }


